import EFOcats_event from '../../../core/v2/event/efocats_event.js';
import EFOcats_curves_event_addCheck from './efocats_curves_event_addCheck.js';
import EFOcats_curves_event_interlock_option from './efocats_curves_event_interlock_option.js';
import EFOcats_curves_event_page from './efocats_curves_event_page.js';

export default class EFOcats_curves_event extends EFOcats_event {
  constructor() {
    super();
    this.page = new EFOcats_curves_event_page();
    this.addCheck = new EFOcats_curves_event_addCheck();

    this.entry1 = new EFOcats_curves_event_interlock_option('entry1_date', 'entry1_time');
    this.entry2 = new EFOcats_curves_event_interlock_option('entry2_date', 'entry2_time');
  }
}
